import { render, staticRenderFns } from "./DashboardCustomizeModal.vue?vue&type=template&id=43706586&scoped=true"
import script from "./DashboardCustomizeModal.vue?vue&type=script&lang=js"
export * from "./DashboardCustomizeModal.vue?vue&type=script&lang=js"
import style0 from "./DashboardCustomizeModal.vue?vue&type=style&index=0&id=43706586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43706586",
  null
  
)

export default component.exports